/* ──────────────────────────────
   src/components/User/UserTable.jsx
   ────────────────────────────── */
import React, { useEffect, useState } from "react";
/* ─── libs ──────────────────────────────────────────── */
import dayjs from "dayjs";
import $ from "jquery";
import axios from "axios";

/* ─── redux ─────────────────────────────────────────── */
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getUser,
  handleBlockUnblockSwitch,
  assignBadge,
  assignFrame,
  assignTag,
  changeUserCountry, // Imported the new action
} from "../../store/user/action";

/* ─── routing ───────────────────────────────────────── */
import { Link, useNavigate } from "react-router-dom";

/* ─── UI / assets ───────────────────────────────────── */
import { Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Male from "../../assets/images/male.png";
import Pagination from "../../pages/Pagination";
import { usePermission } from "../context/PermissionProvider";

/* ─── date-range picker ─────────────────────────────── */
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const UserTable = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { can } = usePermission();

  /* ── paging / filters ─────────────────────────────── */
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("ALL");

  /* calendar */
  const today = new Date();
  const [date, setDate] = useState([
    {
      startDate: new Date(today.getFullYear(), today.getMonth(), 1),
      endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0),
      key: "selection",
    },
  ]);
  const [sDate, setsDate] = useState(
    dayjs().startOf("month").format("YYYY/M/DD")
  );
  const [eDate, seteDate] = useState(
    dayjs().endOf("month").format("YYYY/M/DD")
  );

  const formattedStart =
    sDate === "ALL" ? "ALL" : dayjs(sDate).format("YYYY/M/DD");
  const formattedEnd =
    eDate === "ALL" ? "ALL" : dayjs(eDate).format("YYYY/M/DD");

  /* ── badge state ─────────────────────────────────── */
  const [badgeModalOpen, setBadgeModalOpen] = useState(false);
  const [badgeList, setBadgeList] = useState([]);
  const [badgeMap, setBadgeMap] = useState({}); // { id: image }
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedBadge, setSelectedBadge] = useState("null");

  /* ── frame state ─────────────────────────────────── */
  const [frameModalOpen, setFrameModalOpen] = useState(false);
  const [frameList, setFrameList] = useState([]);
  const [selectedFrame, setSelectedFrame] = useState("null");

  /* ── tag state ───────────────────────────────────── */
  const [tagModalOpen, setTagModalOpen] = useState(false);
  const [tagList, setTagList] = useState([]);
  const [tagMap, setTagMap] = useState({});
  const [selectedTag, setSelectedTag] = useState("null");
  const [selectedTagUser, setSelectedTagUser] = useState(null);

  /* ── country state (NEW) ─────────────────────────── */
  const [countryList, setCountryList] = useState([]);
  const [countryModalOpen, setCountryModalOpen] = useState(false);
  const [selectedCountryUser, setSelectedCountryUser] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");

  /* ── fetch active countries (NEW) ────────────────── */
  useEffect(() => {
    axios
      .get("country/countries/active")
      .then(({ data }) => {
        // Based on your JSON response structure: { countries: [...] }
        if (data && data.countries) {
          setCountryList(data.countries);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  /* ── fetch frames (exclusive only) ───────────────── */
  useEffect(() => {
    axios.get(`svga/all?type=frame`).then(({ data }) => {
      if (!data.status) return;
      setFrameList(data.data.filter((f) => f.exclusive));
    });
  }, []);

  /* ── fetch badges ────────────────────────────────── */
  useEffect(() => {
    axios.get("badge/badges").then(({ data }) => {
      if (!data.status) return;
      setBadgeList(data.badges);
      const map = {};
      data.badges.forEach((b) => (map[b._id.toString()] = b.image));
      setBadgeMap(map);
    });
  }, []);

  /* ── fetch tags once ─────────────────────────────── */
  useEffect(() => {
    axios.get("tag/tags").then(({ data }) => {
      if (data.status) {
        setTagList(data.tags || []);
        const map = {};
        data.tags.forEach((t) => (map[t._id.toString()] = t.image));
        setTagMap(map);
      }
    });
  }, []);

  /* ── fetch users whenever filters change ─────────── */
  useEffect(() => {
    dispatch(
      getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
    );
  }, [
    dispatch,
    activePage,
    rowsPerPage,
    search,
    formattedStart,
    formattedEnd,
  ]);

  const { user, activeUser, male, female, totalUser } = useSelector(
    (state) => state.user
  );
  useEffect(() => setData(user), [user]);

  /* fallback user images */
  useEffect(() => {
    $("img").on("error", function () {
      $(this).attr("src", Male);
    });
  }, []);

  /* ── badge helpers ───────────────────────────────── */
  const openBadgeModal = (u) => {
    setSelectedUser(u);
    setSelectedBadge("null");
    setBadgeModalOpen(true);
  };

  const saveBadge = () => {
    if (!selectedUser || selectedBadge === "null") return;
    props
      .assignBadge({
        userId: selectedUser._id,
        badgeId: selectedBadge,
        action: "add",
      })
      .then(() =>
        dispatch(
          getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
        )
      );
    setBadgeModalOpen(false);
  };

  /* ── frame helpers ───────────────────────────────── */
  const openFrameModal = (user) => {
    setSelectedUser(user);
    setSelectedFrame("null");
    setFrameModalOpen(true);
  };

  const saveFrame = () => {
    if (!selectedUser || selectedFrame === "null") return;
    dispatch(
      assignFrame({
        uniqueId: selectedUser.uniqueId,
        frameId: selectedFrame,
        action: "add",
      })
    ).then(() => {
      dispatch(
        getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
      );
    });
    setFrameModalOpen(false);
  };

  /* ── tag helpers ─────────────────────────────────── */
  const openTagModal = (user) => {
    setSelectedTagUser(user);
    setSelectedTag("null");
    setTagModalOpen(true);
  };

  const saveTag = () => {
    if (!selectedTagUser || selectedTag === "null") return;
    dispatch(
      assignTag({
        userId: selectedTagUser._id,
        tagId: selectedTag,
        action: "add",
      })
    ).then(() => {
      dispatch(
        getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
      );
    });
    setTagModalOpen(false);
  };

  const removeTag = (userId, tagId) => {
    dispatch(
      assignTag({
        userId,
        tagId,
        action: "remove",
      })
    ).then(() => {
      dispatch(
        getUser(activePage, rowsPerPage, search, formattedStart, formattedEnd)
      );
    });
  };

  /* ── country helpers (NEW) ───────────────────────── */
  const openCountryModal = (user) => {
    setSelectedCountryUser(user);
    // Initialize with current user country or default
    setSelectedCountry(user.country || "");
    setCountryModalOpen(true);
  };

  const saveCountry = () => {
    if (!selectedCountryUser || !selectedCountry) return;
    
    // Dispatch action to update country
    props.changeUserCountry({
      userId: selectedCountryUser._id,
      country: selectedCountry,
    });

    setCountryModalOpen(false);
  };

  /* ── misc controls ───────────────────────────────── */
  const handlePageChange = (p) => setActivePage(p);
  const handleRowsChange = (v) => {
    setActivePage(1);
    setRowsPerPage(v);
  };
  const blockToggle = (id) => props.handleBlockUnblockSwitch(id);

  const info = (u) => {
    sessionStorage.setItem("user", JSON.stringify(u));
    navigate("/admin/user/detail");
  };
  const history = (u) => {
    sessionStorage.setItem("user", JSON.stringify(u));
    navigate("/admin/user/history");
  };

  const resetFilter = () => {
    setActivePage(1);
    setRowsPerPage(10);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker").hide();
    dispatch(getUser(1, 10, "ALL", "ALL", "ALL"));
  };

  const applyDateFilter = () => {
    setActivePage(1);
    $("#datePicker").hide();
    dispatch(getUser(1, rowsPerPage, search, formattedStart, formattedEnd));
  };

  const toggleDatePicker = () => $("#datePicker").toggle();

  /* ── badge image helper ──────────────────────────── */
  const getBadgeImg = (badgeItem) => {
    if (badgeItem?.badge && typeof badgeItem.badge === "object") {
      return badgeItem.badge.image ?? "";
    }
    if (badgeMap[badgeItem.badge?.toString?.()]) {
      return badgeMap[badgeItem.badge.toString()];
    }
    return badgeItem.image || "";
  };

  /* ── tag image helper ────────────────────────────── */
  const getTagImg = (tagItem) => {
    if (tagItem && typeof tagItem === "object" && tagItem.image) {
      return tagItem.image;
    }
    if (tagItem?.tag && typeof tagItem.tag === "object") {
      return tagItem.tag.image ?? "";
    }
    const id =
      tagItem?.tag?.toString?.() ||
      tagItem?.toString?.() ||
      tagItem?._id?.toString?.();
    if (id && tagMap[id]) {
      return tagMap[id];
    }
    return "";
  };

  /* ── JSX ─────────────────────────────────────────── */
  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-dark">User</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  User
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-4">
              <div className="card stats-card">
                <div className="card-body">
                  <div className="stats-info">
                    <h5 className="card-title">{male || 0}</h5>
                    <p className="stats-text">Male</p>
                  </div>
                  <div className="stats-icon change-danger">
                    <i className="material-icons">male</i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card stats-card">
                <div className="card-body">
                  <div className="stats-info">
                    <h5 className="card-title">{female || 0}</h5>
                    <p className="stats-text">Female</p>
                  </div>
                  <div className="stats-icon change-success">
                    <i className="material-icons">female</i>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card stats-card">
                <div className="card-body">
                  <div className="stats-info">
                    <h5 className="card-title">{activeUser}</h5>
                    <p className="stats-text">Total Active User</p>
                  </div>
                  <div className="stats-icon change-pink">
                    <i className="material-icons">people</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card" id="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-md-8 d-flex align-items-center">
                  <button className="btn btn-info me-2" onClick={resetFilter}>
                    All
                  </button>

                  <button className="btn btn-info" onClick={toggleDatePicker}>
                    Analytics <ExpandMoreIcon />
                  </button>

                  {formattedStart !== "ALL" && (
                    <p className="my-2 ms-3">
                      {formattedStart} to {formattedEnd}
                    </p>
                  )}
                </div>

                <div className="col-md-4">
                  <div className="input-group mb-3 border rounded-pill">
                    <input
                      id="searchBar"
                      type="search"
                      className="form-control bg-none border-0 rounded-pill"
                      placeholder="What're you searching for?"
                      autoComplete="off"
                      onChange={(e) => setSearch(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          dispatch(
                            getUser(
                              1,
                              rowsPerPage,
                              search,
                              formattedStart,
                              formattedEnd
                            )
                          );
                          setActivePage(1);
                        }
                      }}
                    />

                    <button
                      className="btn text-danger border-0"
                      onClick={() => {
                        setSearch(document.getElementById("searchBar").value);
                        setActivePage(1);
                      }}
                    >
                      <i className="fas fa-search" />
                    </button>
                  </div>
                </div>

                <div
                  id="datePicker"
                  className="date-picker-wrapper mt-5 pt-5"
                  style={{ display: "none" }}
                >
                  <div className="container table-responsive">
                    <DateRangePicker
                      maxDate={today}
                      ranges={date}
                      showSelectionPreview
                      moveRangeOnFirstSelection={false}
                      direction="horizontal"
                      onChange={(item) => {
                        setDate([item.selection]);
                        setsDate(
                          dayjs(item.selection.startDate).format("YYYY/M/DD")
                        );
                        seteDate(
                          dayjs(item.selection.endDate).format("YYYY/M/DD")
                        );
                      }}
                    />
                    <button
                      className="btn btn-danger mt-3"
                      onClick={applyDateFilter}
                    >
                      Apply Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body card-overflow pt-0">
              <table className="table table-striped mt-5 text-center">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Image</th>
                    <th>Badge</th>
                    <th>Exclusive Frame</th>
                    <th>Tag</th>
                    <th>Name</th>
                    <th>UniqueId</th>
                    <th>Gender</th>
                    <th>RCoin</th>
                    <th>Country</th>
                    <th>Level</th>
                    <th>isBlock</th>
                    <th>isHost</th>
                    <th>Agency</th>
                    <th>Info</th>
                    <th>History</th>
                  </tr>
                </thead>

                <tbody>
                  {data.length ? (
                    data.map((u, i) => (
                      <tr key={u._id}>
                        <td>{(activePage - 1) * rowsPerPage + i + 1}</td>

                        <td>
                          <img
                            src={u.image || Male}
                            alt="user"
                            height="50"
                            width="50"
                            style={{
                              objectFit: "cover",
                              borderRadius: 10,
                              border: "2px solid #000000",
                            }}
                          />
                        </td>

                        {/* Badges */}
                        <td style={{ minWidth: 120 }}>
                          {u.badges?.length
                            ? u.badges.map((b) => {
                                const imgSrc = getBadgeImg(b);
                                if (!imgSrc) return null;
                                return (
                                  <img
                                    key={b.badge?._id ?? b.badge}
                                    src={imgSrc}
                                    alt="badge"
                                    height="28"
                                    width="28"
                                    title={b.name}
                                    className="me-1 mb-1 rounded"
                                    style={{
                                      objectFit: "cover",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      props
                                        .assignBadge({
                                          userId: u._id,
                                          badgeId: b.badge?._id ?? b.badge,
                                          action: "remove",
                                        })
                                        .then(() =>
                                          dispatch(
                                            getUser(
                                              activePage,
                                              rowsPerPage,
                                              search,
                                              formattedStart,
                                              formattedEnd
                                            )
                                          )
                                        )
                                    }
                                  />
                                );
                              })
                            : "-"}
                          {can("admin/user", "Edit") && (
                            <button
                              className="btn btn-xs btn-outline-primary d-block mt-1"
                              onClick={() => openBadgeModal(u)}
                            >
                              Add
                            </button>
                          )}
                        </td>

                        {/* Frames */}
                        <td style={{ minWidth: 120 }}>
                          {Array.isArray(u.assignedFrames) &&
                          u.assignedFrames.length > 0 ? (
                            u.assignedFrames.map((frame) => (
                              <img
                                key={frame._id}
                                src={`https://admin.umochat.shop/${frame.image}`}
                                alt={frame.name}
                                height="28"
                                width="28"
                                className="me-1 mb-1 rounded"
                                style={{
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  props
                                    .assignFrame({
                                      uniqueId: u.uniqueId,
                                      frameId: frame._id,
                                      action: "remove",
                                    })
                                    .then(() =>
                                      dispatch(
                                        getUser(
                                          activePage,
                                          rowsPerPage,
                                          search,
                                          formattedStart,
                                          formattedEnd
                                        )
                                      )
                                    )
                                }
                                title={`Remove ${frame.name}`}
                              />
                            ))
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                          {can("admin/user", "Edit") && (
                            <button
                              className="btn btn-xs btn-outline-primary"
                              onClick={() => openFrameModal(u)}
                            >
                              {u.assignedFrames?.length ? "Re-assign" : "Assign"}
                            </button>
                          )}
                        </td>

                        {/* TAG COLUMN */}
                        <td style={{ minWidth: 120 }}>
                          {u.tags?.length
                            ? u.tags.map((t) => {
                                const imgSrc = getTagImg(t);
                                if (!imgSrc) return null;
                                return (
                                  <img
                                    key={t._id || t}
                                    src={imgSrc}
                                    alt="tag"
                                    height="28"
                                    width="28"
                                    title={t.name}
                                    className="me-1 mb-1 rounded"
                                    style={{
                                      objectFit: "cover",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      const tagIdToSend =
                                        t.tag?._id ||
                                        (typeof t.tag === "string"
                                          ? t.tag
                                          : null) ||
                                        t._id ||
                                        t;
                                      removeTag(u._id, tagIdToSend);
                                    }}
                                  />
                                );
                              })
                            : "-"}
                          {can("admin/user", "Edit") && (
                            <button
                              className="btn btn-xs btn-outline-primary d-block mt-1"
                              onClick={() => openTagModal(u)}
                            >
                              Add
                            </button>
                          )}
                        </td>

                        <td>{u.name || "-"}</td>
                        <td>{u.uniqueId || "-"}</td>
                        <td>{u.gender || "-"}</td>
                        <td className="text-danger">{u.rCoin || 0}</td>

                        {/* Country Column with Edit Button */}
                        <td className="text-success">
                          {u.country || "-"}
                          {can("admin/user", "Edit") && (
                            <button
                              className="btn btn-sm text-primary ms-2 p-0"
                              onClick={() => openCountryModal(u)}
                              title="Edit Country"
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          )}
                        </td>

                        <td className="text-warning">
                          {u.level?.name || "-"}
                        </td>

                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={u.isBlock}
                              onChange={() => {
                                if (can("admin/user", "Edit")) {
                                  blockToggle(u._id);
                                }
                              }}
                              disabled={!can("admin/user", "Edit")}
                            />
                            <span className="slider">
                              <p
                                style={{
                                  fontSize: 12,
                                  marginLeft: u.isBlock ? "-24px" : "35px",
                                  marginTop: 6,
                                  color: "#000",
                                }}
                              >
                                {u.isBlock ? "Yes" : "No"}
                              </p>
                            </span>
                          </label>
                        </td>

                        <td>{u.isHost ? "Yes" : "No"}</td>
                        <td>{u.isHost ? u.agency?.name : "---"}</td>

                        <td>
                          <Tooltip title="Info">
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() => info(u)}
                            >
                              <i className="fas fa-info-circle" />
                            </button>
                          </Tooltip>
                        </td>

                        <td>
                          <Tooltip title="History">
                            <button
                              className="btn btn-sm btn-success"
                              onClick={() => history(u)}
                            >
                              <i className="fas fa-history" />
                            </button>
                          </Tooltip>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="16" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={totalUser}
                handleRowsPerPage={handleRowsChange}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Frame Modal */}
      {frameModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedUser?.name} – Assign Exclusive Frame
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setFrameModalOpen(false)}
                />
              </div>
              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedFrame}
                  onChange={(e) => setSelectedFrame(e.target.value)}
                >
                  <option value="null">Choose frame…</option>
                  {frameList.map((f) => (
                    <option key={f._id} value={f._id}>
                      {f.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setFrameModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={selectedFrame === "null"}
                  onClick={saveFrame}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Badge Modal */}
      {badgeModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedUser?.name} – Add badge</h5>
                <button
                  className="btn-close"
                  onClick={() => setBadgeModalOpen(false)}
                />
              </div>
              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedBadge}
                  onChange={(e) => setSelectedBadge(e.target.value)}
                >
                  <option value="null">Choose badge…</option>
                  {badgeList.map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setBadgeModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={selectedBadge === "null"}
                  onClick={saveBadge}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tag Modal */}
      {tagModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedTagUser?.name} – Assign Tag
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setTagModalOpen(false)}
                />
              </div>
              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedTag}
                  onChange={(e) => setSelectedTag(e.target.value)}
                >
                  <option value="null">Choose tag…</option>
                  {tagList.map((t) => (
                    <option key={t._id} value={t._id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setTagModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={selectedTag === "null"}
                  onClick={saveTag}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Country Modal (NEW) */}
      {countryModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Edit Country for {selectedCountryUser?.name}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setCountryModalOpen(false)}
                />
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Select Country</label>
                  <select
                    className="form-select mt-2"
                    value={selectedCountry}
                    onChange={(e) => setSelectedCountry(e.target.value)}
                  >
                    <option value="">-- Select Country --</option>
                    {countryList.length > 0 ? (
                      countryList.map((c) => (
                        <option key={c._id} value={c.name}>
                          {c.name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No active countries found</option>
                    )}
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setCountryModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!selectedCountry}
                  onClick={saveCountry}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect(null, {
  getUser,
  handleBlockUnblockSwitch,
  assignBadge,
  assignFrame,
  assignTag,
  changeUserCountry, // Connect new action
})(UserTable);
